export default __webpack_public_path__ + "static/media/print.7b1fc489.svg";